import { useSyncExternalStore } from 'react';
import { offlineStore, type OfflineSnapshot, type OfflineStore } from './offline-store';

/**
 * EU-711 — lê o estado de conectividade da UI. `useSyncExternalStore` porque a
 * fonte é externa ao React (eventos da window + o transporte HTTP) e o React 18
 * exige essa ponte para não rasgar o render entre leituras.
 */
export function useOfflineState(store: OfflineStore = offlineStore): OfflineSnapshot {
  return useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
}
